import { render } from "./MetricsandFinancials.vue?vue&type=template&id=5b822444"
import script from "./MetricsandFinancials.vue?vue&type=script&lang=js"
export * from "./MetricsandFinancials.vue?vue&type=script&lang=js"

import "./MetricsandFinancials.vue?vue&type=style&index=0&id=5b822444&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__